import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { IconButton, Typography } from '@mui/material';
import { RefObject } from 'react';

export const BottomNavigationAction = ({
  icon,
  ref,
  label,
  color,
}: {
  ref: RefObject<ImperativeFormDialogRefType | null>;
  icon: React.ReactNode;
  label: string;
  color?: string;
}) => {
  return (
    <IconButton
      aria-label={label}
      onClick={() => ref.current?.open()}
      sx={{
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 1,
        gap: 0.5,
        color: color,
        transition: 'opacity 0.2s',
      }}
    >
      {icon}
      <Typography fontWeight={400} fontSize="0.7rem" color={color}>
        {label}
      </Typography>
    </IconButton>
  );
};
